import React, { useEffect } from 'react';
import TourMain from './TourMain';
import './Tour.scss';


const Tour = () => {

useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="Tour">
      <TourMain />
    </div>
  );
};

export default Tour;
